import {LanguageService} from "../../serverService/languageService/LanguageService";
import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoChipSizeType,
    RaikoChipTypes,
    RaikoCustomSimpleChip,
    RaikoCustomTable,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoTableTitleContainer,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import AddNewLanguage from "./addNewLanguage/addNewLanguage";

export default function LanguageSetting() {

    let page = 0
    const size = 15

    const service = new LanguageService();


    const [numberOfItems, setNumberOfItems] = useState(0);
    const [languageListData, setLanguageListData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);

    const [selectedLanguage, setSelectedLanguage] = useState(-1);

    const [isNeedRefresh, setIsNeedRefresh] = useState(false);

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getLanguageListFromServer()
        }
    }, []);

    function generateLanguageRowItem(id, number, name, locale, enabled, calendarType, direction) {
        return {
            id,
            number,
            name,
            locale,
            direction,
            calendarType,
            enabled: enabled ?
                <RaikoCustomSimpleChip
                    title={"فعال"}
                    type={RaikoChipTypes.success}
                    size={RaikoChipSizeType.small}
                /> :
                <RaikoCustomSimpleChip
                    title={"غیرفعال"}
                    type={RaikoChipTypes.error}
                    size={RaikoChipSizeType.small}
                />
        }
    }

    function handlePagination(newPage) {
        page = newPage;
        getLanguageListFromServer()
    }

    function handleShowDetail(rowId) {
        setSelectedLanguage(rowId)
        handleOpenDialog()
    }

    const [openLanguageDialogState, setOpenLanguageDialogState] = useState(false);

    function handleOpenDialog() {
        setOpenLanguageDialogState(true)
    }

    function handleCloseDialog() {
        setSelectedLanguage(-1)
        setOpenLanguageDialogState(false)
        getLanguageListFromServer()
        if (isNeedRefresh) {
            setIsNeedRefresh(false)
            page = 0
            getLanguageListFromServer()
        }

    }

    function getLanguageListFromServer() {
        setTableLoading(true)
        service.getLanguageList(page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setLanguageListData([])
                response.data.map((item, index) => {
                    setLanguageListData(prevState => [
                        ...prevState,
                        generateLanguageRowItem(
                            item.id,
                            (page * size) + index + 1,
                            item.name,
                            item.code,
                            item.enabled,
                            item.calendarType,
                            item.direction,
                        )
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    return (
        <>
            <Helmet><title>{RouteHelper.LanguageSetting.name}</title></Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openLanguageDialogState}
                dialogSize={DialogSize.WRAP_CONTENT}
                hasCloseButton={false}
            >
                <AddNewLanguage
                    changeNeedRefresh={setIsNeedRefresh}
                    selectedLanguage={selectedLanguage}
                    handleCloseDialog={handleCloseDialog}
                />
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.Settings.name,
                            ""
                        ),
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.LanguageSetting.name,
                            ""
                        ),
                    ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"زبان ها"}
                                amount={numberOfItems}
                                hasCreateNewItem
                                handleCreateNewItem={handleOpenDialog}
                            />
                            <RaikoCustomTable
                                header={languageListHeader}
                                data={languageListData}
                                pageCount={pageCount}
                                handlePaginationChange={handlePagination}
                                isLoading={tableLoading}
                                rowClicked={handleShowDetail}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}

const languageListHeader = [
    {
        id: "number",
        label: "#"
    }, {
        id: "name",
        label: "نام"
    }, {
        id: "locale",
        label: "کد زبان"
    }, {
        id: "calendarType",
        label: "تقویم"
    }, {
        id: "direction",
        label: "جهت نوشتار"
    }, {
        id: "enabled",
        label: "وضعیت"
    },
]